/**
 * Лэндинги курсов: локальные интерактивы (табы + Swiper преподавателей)
 */

function initLandingTeachersSwiper() {
  const swiperRoot = document.querySelector('.lp-teachers__swiper')
  if (!swiperRoot || typeof window.Swiper !== 'function') return

  new window.Swiper(swiperRoot, {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    navigation: {
      nextEl: '.lp-teachers-next',
      prevEl: '.lp-teachers-prev',
    },
    breakpoints: {
      576: { slidesPerView: 2 },
      992: { slidesPerView: 3 },
    },
  })
}

function initLandingProgramTabs() {
  const tabs = document.querySelectorAll('.lp-program__tab')
  const panels = document.querySelectorAll('.lp-program__panel')
  if (!tabs.length || !panels.length) return

  tabs.forEach((tab) => {
    // Защита от повторной инициализации при повторных вызовах.
    if (tab.dataset.lpBound === '1') return
    tab.dataset.lpBound = '1'

    tab.addEventListener('click', function onTabClick() {
      const target = this.dataset.tab

      tabs.forEach((item) => {
        item.classList.remove('is-active')
        item.setAttribute('aria-selected', 'false')
      })

      panels.forEach((panel) => panel.classList.remove('is-active'))

      this.classList.add('is-active')
      this.setAttribute('aria-selected', 'true')

      const currentPanel = document.querySelector(`[data-panel="${target}"]`)
      if (currentPanel) currentPanel.classList.add('is-active')
    })
  })
}

function initSummerCountdown() {
  const els = document.querySelectorAll('.si-countdown[data-deadline]')
  if (!els.length) return

  function pad(n) { return String(n).padStart(2, '0') }
  function tick() {
    els.forEach(el => {
      const diff = new Date(el.dataset.deadline).getTime() - Date.now()
      if (diff <= 0) {
        el.innerHTML = '<span style="opacity:.6;font-size:.85rem">Акция завершена</span>'
        return
      }
      const d = Math.floor(diff / 86400000)
      const h = Math.floor((diff % 86400000) / 3600000)
      const m = Math.floor((diff % 3600000) / 60000)
      const dn = el.querySelector('[data-unit="days"]')
      const hn = el.querySelector('[data-unit="hours"]')
      const mn = el.querySelector('[data-unit="mins"]')
      if (dn) dn.textContent = pad(d)
      if (hn) hn.textContent = pad(h)
      if (mn) mn.textContent = pad(m)
    })
  }
  tick()
  setInterval(tick, 60000)
}

export function initLandingPages() {
  initLandingTeachersSwiper()
  initLandingProgramTabs()
  initLandingImageFallbacks()
  initSummerCountdown()
}

function applyHeroFallback(img, gradient) {
  img.style.background = gradient
  img.style.height = '360px'
  img.style.borderRadius = '20px'
}

function initLandingImageFallbacks() {
  const fallbackImages = document.querySelectorAll('img[data-on-error]')
  if (!fallbackImages.length) return

  fallbackImages.forEach((img) => {
    if (img.dataset.lpErrorBound === '1') return
    img.dataset.lpErrorBound = '1'

    img.addEventListener('error', () => {
      const mode = img.dataset.onError

      if (mode === 'hide') {
        img.style.display = 'none'
        return
      }

      if (mode === 'hero-kids') {
        applyHeroFallback(img, 'linear-gradient(135deg,#e8f8e8,#c8ecc8)')
        return
      }

      if (mode === 'hero-teens') {
        applyHeroFallback(img, 'linear-gradient(135deg,#e8edf8,#c8d4f0)')
        return
      }

      if (mode === 'hero-adults') {
        applyHeroFallback(img, 'linear-gradient(135deg,#ffe8e8,#ffd4d4)')
        return
      }

      if (mode === 'hero-chinese') {
        applyHeroFallback(img, 'linear-gradient(135deg,#fff5e6,#ffe4bc)')
      }
    })
  })
}
